import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function AboutPage() {
  useEffect(() => {
    const aboutSchema = {
      '@context': 'https://schema.org',
      '@type': 'AboutPage',
      name: '关于我们 - aaa一级日韩',
      description: 'aaa一级日韩是专注于日韩影视娱乐内容的综合资讯平台，致力于为华语地区的日韩文化爱好者提供最新、最全的娱乐资讯。',
      url: 'https://aaa-rikhan.example.com/about',
      isPartOf: {
        '@type': 'WebSite',
        name: 'aaa一级日韩',
        url: 'https://aaa-rikhan.example.com/',
      },
    };

    const breadcrumbSchema = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: '首页',
          item: 'https://aaa-rikhan.example.com/',
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: '关于我们',
        },
      ],
    };

    const faqSchema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: 'aaa一级日韩提供哪些内容？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '我们提供日本和韩国的影视资讯、剧集推荐、K-POP与J-POP音乐动态、综艺节目信息以及明星动态等全方位的娱乐内容。',
          },
        },
        {
          '@type': 'Question',
          name: '网站内容多久更新一次？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '我们的编辑团队每日更新内容，确保您第一时间获取最新的日韩娱乐资讯。',
          },
        },
        {
          '@type': 'Question',
          name: '如何联系我们？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '您可以通过本页面的联系表单、发送邮件至 contact@aaa-rikhan.com 或关注我们的社交媒体账号与我们取得联系。',
          },
        },
      ],
    };

    const scripts = [
      JSON.stringify(aboutSchema),
      JSON.stringify(breadcrumbSchema),
      JSON.stringify(faqSchema),
    ];
    scripts.forEach((s) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = s;
      document.head.appendChild(script);
    });

    return () => {
      document.head.querySelectorAll('script[type="application/ld+json"]').forEach((el) => {
        if (scripts.some((s) => el.textContent === s)) el.remove();
      });
    };
  }, []);

  const testimonials = [
    {
      name: '小陈',
      role: '日剧爱好者',
      content: '每天必刷aaa一级日韩，日剧推荐太准了！自从关注了这个网站，再也没缺过好剧看。',
      rating: 5,
    },
    {
      name: 'Minji',
      role: 'K-POP粉丝',
      content: '作为BLACKPINK的铁粉，这里的K-POP资讯更新速度超快，回归消息永远第一时间就知道。',
      rating: 5,
    },
    {
      name: '老王',
      role: '电影迷',
      content: '日韩电影板块做得特别好，影评分析很专业，让我发现了不少小众佳作。强烈推荐！',
      rating: 5,
    },
  ];

  return (
    <>
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-100 border-b border-background-200/70">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-8 md:py-10">
            <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-4 flex-wrap">
              <Link to="/" className="hover:text-primary-600 transition-colors duration-200 cursor-pointer">首页</Link>
              <i className="ri-arrow-right-s-line text-[10px]"></i>
              <span className="text-foreground-700 font-medium">关于我们</span>
            </nav>
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              关于我们
            </h1>
            <p className="mt-2 text-sm text-foreground-600">了解aaa一级日韩的故事</p>
          </div>
        </div>

        <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">
                品牌介绍
              </h2>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                <strong>aaa一级日韩</strong>成立于2024年，是华语地区领先的日韩娱乐资讯平台。我们致力于为喜爱日本和韩国文化的朋友们提供<strong>最新、最全、最优质</strong>的娱乐内容。
              </p>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                从日剧韩剧的深度推荐，到K-POP与J-POP的最新动态；从日本韩国电影的精彩影评，到热门综艺的追踪报道——我们覆盖日韩娱乐的每一个角落，让你的追剧追星之旅更加精彩。
              </p>
              <p className="text-sm text-foreground-700 leading-relaxed">
                我们的编辑团队由一群热爱日韩文化的年轻人组成，分布在东京、首尔、北京、上海等地，确保我们能够第一时间获取最前沿的资讯。
              </p>
            </div>
            <div className="relative overflow-hidden rounded-lg aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20creative%20office%20workspace%20with%20entertainment%20media%20elements%2C%20warm%20ambient%20lighting%2C%20cozy%20atmosphere%2C%20minimalist%20design%2C%20wooden%20desk%20with%20laptop%20and%20coffee%2C%20editorial%20photography%20with%20soft%20natural%20light%2C%20clean%20aesthetic&width=800&height=600&seq=about-brand&orientation=landscape"
                alt="aaa一级日韩品牌形象"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </section>

        <section className="bg-background-100 border-y border-background-200/70">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-20">
            <div className="text-center mb-10">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
                用户口碑
              </h2>
              <p className="mt-2 text-sm text-foreground-600">
                听听我们的用户怎么说
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {testimonials.map((t, i) => (
                <div key={i} className="p-6 rounded-lg bg-background-50 border border-background-200/70">
                  <div className="flex items-center gap-0.5 mb-3">
                    {Array.from({ length: t.rating }).map((_, j) => (
                      <i key={j} className="ri-star-fill text-sm text-accent-500"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    &ldquo;{t.content}&rdquo;
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center">
                      <span className="text-xs font-semibold text-primary-700">{t.name[0]}</span>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-950">{t.name}</p>
                      <p className="text-xs text-foreground-500">{t.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-6 text-center">
              {[
                { value: '100,000+', label: '月活跃用户' },
                { value: '5,000+', label: '原创文章' },
                { value: '98%', label: '用户满意度' },
                { value: '365天', label: '全年无休更新' },
              ].map((stat, i) => (
                <div key={i}>
                  <p className="text-2xl md:text-3xl font-heading font-bold text-primary-600">{stat.value}</p>
                  <p className="text-xs text-foreground-500 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="max-w-[800px] mx-auto px-4 md:px-6 py-14 md:py-20">
          <div className="text-center mb-8">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              联系我们
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              有任何问题或合作意向，欢迎随时联系我们
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-10">
            <div className="p-5 rounded-lg bg-background-100 border border-background-200/70 text-center">
              <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-50 text-primary-600">
                <i className="ri-mail-line text-lg"></i>
              </div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-1">电子邮件</h4>
              <p className="text-xs text-foreground-500">contact@aaa-rikhan.com</p>
            </div>
            <div className="p-5 rounded-lg bg-background-100 border border-background-200/70 text-center">
              <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-50 text-accent-600">
                <i className="ri-wechat-line text-lg"></i>
              </div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-1">微信公众号</h4>
              <p className="text-xs text-foreground-500">aaa一级日韩</p>
            </div>
            <div className="p-5 rounded-lg bg-background-100 border border-background-200/70 text-center">
              <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-secondary-50 text-secondary-700">
                <i className="ri-weibo-line text-lg"></i>
              </div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-1">微博</h4>
              <p className="text-xs text-foreground-500">@aaa一级日韩</p>
            </div>
          </div>

          <ContactForm />
        </section>
      </main>
      <Footer />
    </>
  );
}

function ContactForm() {
  const formUrl = 'https://readdy.ai/api/form/d9pmnj6b4qjhggaeq1c0';

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.querySelector('[name="website_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      const el = document.getElementById('contact-form-status');
      if (el) el.textContent = '感谢您的留言，我们会尽快回复！';
      return;
    }

    const formData = new FormData(form);
    try {
      const res = await fetch(formUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const text = await res.text();
      let msg = '';
      try {
        const parsed = JSON.parse(text);
        if (res.ok && parsed?.code === 'OK') {
          msg = '感谢您的留言，我们会尽快回复！';
          form.reset();
        } else {
          msg = parsed?.meta?.message || parsed?.message || '提交失败，请稍后再试。';
        }
      } catch {
        msg = res.ok ? '感谢您的留言！' : '提交失败，请稍后再试。';
      }
      const el = document.getElementById('contact-form-status');
      if (el) el.textContent = msg;
    } catch {
      const el = document.getElementById('contact-form-status');
      if (el) el.textContent = '网络错误，请稍后再试。';
    }
  };

  return (
    <form
      id="contact-form"
      data-readdy-form=""
      onSubmit={handleSubmit}
      className="space-y-4"
    >
      <div className="honeypot-wrapper">
        <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label htmlFor="contact-name" className="block text-xs font-medium text-foreground-700 mb-1.5">姓名</label>
          <input
            type="text"
            id="contact-name"
            name="name"
            required
            className="w-full px-3 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors duration-200"
            placeholder="请输入您的姓名"
          />
        </div>
        <div>
          <label htmlFor="contact-email" className="block text-xs font-medium text-foreground-700 mb-1.5">邮箱</label>
          <input
            type="email"
            id="contact-email"
            name="email"
            required
            className="w-full px-3 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors duration-200"
            placeholder="请输入您的邮箱"
          />
        </div>
      </div>
      <div>
        <label htmlFor="contact-subject" className="block text-xs font-medium text-foreground-700 mb-1.5">主题</label>
        <input
          type="text"
          id="contact-subject"
          name="subject"
          required
          className="w-full px-3 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors duration-200"
          placeholder="请输入留言主题"
        />
      </div>
      <div>
        <label htmlFor="contact-message" className="block text-xs font-medium text-foreground-700 mb-1.5">留言内容</label>
        <textarea
          id="contact-message"
          name="message"
          required
          maxLength={500}
          rows={5}
          className="w-full px-3 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors duration-200 resize-none"
          placeholder="请输入您的留言内容（最多500字）"
        ></textarea>
      </div>
      <div>
        <button
          type="submit"
          className="px-8 py-3 rounded-md bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
        >
          发送留言
        </button>
      </div>
      <p id="contact-form-status" className="text-xs text-foreground-600 min-h-[16px]"></p>
    </form>
  );
}